import React, { useEffect, useRef, useState } from "react";
import { FaFacebookF, FaInstagram  } from "react-icons/fa";
import { FaThreads } from 'react-icons/fa6';
import "./HeroIntro.css";

export default function HeroIntro() {
  const videoRef = useRef(null);
  const [showContent, setShowContent] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const vid = videoRef.current;

    vid.onended = () => {
      setShowOverlay(true);     // overlay appears
      setTimeout(() => {
        setShowContent(true);   // content fades in
      }, 600);
    };
  }, []);

  return (
    <div className="hero-container">
<div className="top-contact">
  <span
    onClick={() =>
      window.location.href = "https://contact-us.dzylo.com/antarahaus"
    }
  >
    Contact Us
  </span>
</div>

      <video
        ref={videoRef}
        className="hero-video"
        src="/videos/ComingSoon.mp4"  // replace with your actual video path
        autoPlay
        muted
        playsInline
      />
 {/* Overlay appears only AFTER video ends */}
      <div className={`hero-overlay ${showOverlay ? "visible" : ""}`}></div>

      {/* Text fades in AFTER overlay */}
      <div className={`hero-content ${showContent ? "visible" : ""}`}>
        <h2 className="company">Antara <span>Haus</span></h2>
    {/* <p className="launching">LAUNCHING SOON</p> */}
        <h1 className="headline">Turning Houses Into Thoughtfully Made Homes.</h1>
        <p className="subtext">Crafted with Precision, Designed to Inspire. </p>
         <p className="subtext1"> Kitchens | Wardrobes | Living Spaces</p>

        <div className="social-icons">
      <a href="https://www.facebook.com/share/1RfefQzbox/?mibextid=wwXIfr" className="icon fb"><FaFacebookF /></a>
      <a href="https://www.instagram.com/antarahaus?igsh=MXFra2Zwc3lmc2ZocQ==" className="icon insta"><FaInstagram /></a>
      <a href="https://www.threads.com/@antarahaus?igshid=NTc4MTIwNjQ2YQ==" className="icon yt"><FaThreads  /></a>
    </div>

      <div className="footer-contact-wrapper">
      {/* Left Section  onClick={() => window.location.href = "https://contact-us.dzylo.com/antarahaus"}
  style={{ cursor: "pointer" }} */}
      <div className="footer-section">
        <span className="footer-title" >Contact</span>
        <div className="footer-text">
          <p>Telephone: +91 9551336177</p>
          <p>Email: arjun@antarahaus.in</p>
        </div>
      </div>

      {/* Right Section 
      <div className="footer-section align-right">
        <span className="footer-title">Head Office</span>
        <div className="footer-text">
          <p>Metrozone VR Mall</p>
          <p>Chennai</p>
        </div>
      </div>*/}
    </div>
    

      </div>
    </div>
  );
}
